import React from "react";
import { Link } from "react-router-dom";
import { Container, Modal, Row, Card, Col, Input, Button, FormGroup,UncontrolledTooltip } from "reactstrap";
import TableComponent from "../../../components/Common/TableComponent";
import { getSubExpertises, removeSubExpertise, getExpertiseFilter } from "../../../services/expertizeService";
import AddTopic from "./AddSubExpertise";
import { notifyError, notifySuccess } from "../../../utils/utils";
import PaginationComponent from "../../../components/Common/Pagination";

import SweetAlert from "react-bootstrap-sweetalert";

class SubExpertises extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 0,
            search: "",
            limit: 25,
            sort: "sub_expertise_id",
            asc: false,
            total_count: 0,
            topic_master_id: "",
            subExpertises: [],
            subExpertise: {},
            expertiseOptions: [],
            alertModel: false,
            alertMessage: "",
            isEditing: false,
            modelOpen: false,
            loading: false
        };

        this.changePage = this.changePage.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.deleteTopic = this.deleteTopic.bind(this);
    }


    applySort = key => {
        if (this.state.sort === key) {
            this.setState({ asc: !this.state.asc });
        } else {
            this.setState({ sort: key, asc: true });
        }
        this.changePage(0);
    }

    toggleModal(value) {
        this.setState({
            modelOpen: !this.state.modelOpen,
            subExpertise: this.state.modelOpen ? {} : value,
            isEditing: value ? true : false
        })
    }


    changePage(pageNumber) {

        this.setState({ page: pageNumber });

        const req = {
            offset: pageNumber,
            limit: this.state.limit,
            search: this.state.search,
            expertise_id: this.state.expertise_master_id,
            sort: this.state.sort,
            asc: this.state.asc
        };
        this.setState({ loading: true });

        getSubExpertises(req)
            .then(response => {
                this.setState({ loading: false });
                const { data } = response;

                if (data.status) {
                    this.setState({
                        subExpertises: data.subexpertises,
                        total_count: data.totalCount
                    });
                } else {
                    notifyError(data.message);
                    this.setState({
                        subExpertises: [],
                        total_count: 0
                    });
                }

            })
    }

    deleteTopic() {
        removeSubExpertise(this.state.id)
            .then(res => {
                const { data } = res;
                if (data.status) {
                    notifySuccess(data.message);
                    this.setState({ alert_confirm: false });
                    this.changePage(this.state.page);
                } else {
                    notifyError(data.message);
                }
            });
    }

    componentDidMount() {
        this.changePage(0);

        getExpertiseFilter()
            .then(res => {
                const { data } = res;
                if (data.status) {
                    this.setState({
                        expertiseOptions: data.expertises
                    });
                }
            })
    }
    applySort = key => {
        console.log(key);
        if (this.state.sort === key) {
            this.setState({ asc: !this.state.asc }, () => this.changePage(0));
        } else {
            this.setState({ sort: key, asc: true }, () => this.changePage(0));
        }
    }
    render() {

        const columns = [
            // {
            //     Header: "No.",
            //     accessor: "sub_topic_id",
            //     Cell: ({row}) => (this.state.page * 20) + (row.index + 1)
            // },
            {
                Header: () => "Sub Expertise Id",
                accessor: "sub_expertise_id",
                sortable: true,
                Cell: ({ row }) => <span>{row.original.sub_expertise_id}</span>,
            },
            {
                Header: "Sub Expertises",
                accessor: "sub_expertise_name",
                sortable: true,
                Cell: ({ row }) => {
                    return (
                        <>
                            <span>{row.original.sub_expertise_name}</span>
                        </>
                    )
                }
            },
            {
                Header: "Expertise",
                accessor: "expetise",
                sortable: false,
                Cell: ({ row }) => {
                    return (
                        <>
                            <span>{row.original.expertise ? row.original.expertise.expertise_name : "NA"}</span>
                        </>
                    )
                }
            },
            {
                Header: "Action",
                sortable: false,
                Cell: ({ row }) =>
                    <>
                        {/* <Button
                            onClick={e => {
                                this.toggleModal(row.original);
                            }}
                            className="mr-3 bg-white no-border"
                        >
                            <i className="mdi mdi-pencil text-primary font-size-18"></i>
                        </Button>

                        <Button 
                            to={`#`} 
                            onClick={() => {
                                // this.deleteTopic(row.original.sub_expertise_id)
                                this.setState({
                                    id: row.original.sub_expertise_id,
                                    alert_confirm: true
                                })
                            }} 
                            className="mr-3 bg-white no-border " 
                            id="edit6"
                        ><i className="fa fa-trash text-danger font-size-18"></i></Button> */}

                        <Link 
                            to={`#`} 
                            className="mr-3 text-info" id={`edit_${row.original.sub_expertise_id}`}
                            onClick={e => { 
                                this.toggleModal(row.original);
                            }}  ><i className="fa fa-edit font-size-18"></i></Link>
                        <UncontrolledTooltip placement="top" target={`edit_${row.original.sub_expertise_id}`}>
                            Edit
                        </UncontrolledTooltip >

                        <span id={`delete_${row.original.sub_expertise_id}`}><i className="text-danger fas fa-trash" onClick={e => {
                           this.setState({ id: row.original.sub_expertise_id, alert_confirm: true })
                        }}></i></span>
                        <UncontrolledTooltip placement="top" target={`delete_${row.original.sub_expertise_id}`}>
                            Delete
                        </UncontrolledTooltip >
                    </>
            }
        ];

        return (
            <React.Fragment>
                <div className="page-content">

                    <Container fluid>

                        <Card style={{"height": "100vh"}}>
                            <h3 className="p-3"> Sub Expertises </h3>
                            <hr />
                            <Row className="p-2">
                                <Col lg={3} md={3} sm={6} xs={6} >

                                    <FormGroup>
                                        {/* <Label></Label> */}
                                        <Input
                                            type="select"
                                            name="topic_master_id"
                                            value={this.state.expertise_master_id}
                                            onChange={e => {
                                                this.setState({
                                                    expertise_master_id: e.target.value
                                                }, () => this.changePage(0));
                                                // this.changePage(0);
                                            }}
                                        >
                                            <option value="">Select</option>
                                            {this.state.expertiseOptions && this.state.expertiseOptions.map((x, i) =>
                                                <option key={i} value={x.expertise_id}>{x.expertise_name}</option>
                                            )}
                                        </Input>
                                    </FormGroup>
                                </Col>

                                <Col lg={9} md={9} sm={12} xs={12}>
                                    <div className="form-inline float-md-right">
                                        <Button
                                            color="info"
                                            className="mr-3 no-border text-white"
                                            onClick={() => {
                                                this.setState({
                                                    modelOpen: true,
                                                    isEditing: false
                                                });
                                            }}
                                        >
                                            <i className="fas fa-plus"></i>   Add
                                        </Button>

                                        <div className="search-box ml-2">
                                            <div className="position-relative">

                                                <Input
                                                    onChange={e => {
                                                        this.setState(
                                                            { search: e.target.value },
                                                            () => this.changePage(0)
                                                        );
                                                    }}
                                                    bsSize="lg"
                                                    type="text"
                                                    name="search"
                                                    value={this.state.search}
                                                    className="form-control rounded"
                                                    placeholder="Sub Expertise"
                                                />
                                                <i className="mdi mdi-magnify search-icon"></i>
                                            </div>
                                        </div>
                                    </div>

                                </Col>
                            </Row>

                            <div className="table-responsive mt-2 p-1 scrollbar" style={{ overflowY:"auto", "maxHeight": "1000px" }}>
                                <TableComponent
                                    columns={columns}
                                    data={this.state.subExpertises}
                                    sort={this.state.sort}
                                    asc={this.state.asc}
                                    applySort={this.applySort}
                                    loading={this.state.loading}
                                />
                            </div>
                            <div style={{"position":"absolute","bottom":"10px","width":"100%","zIndex":"99999", backgroundColor: "white"}}>

                            {
                                this.state.total_count > 0 ?

                                <PaginationComponent
                                total_count={this.state.total_count}
                                page={this.state.page}
                                limit={this.state.limit}
                                changePage={this.changePage}
                                changeFilter={e => {
                                    this.setState({ limit: e.target.value }, () => this.changePage(0));
                                }}
                                />  : ""
                            }
                            </div>
                        </Card>
                    </Container>
                </div>

                {this.state.alert_confirm ? (
								<SweetAlert
									title="Are you sure?"
									warning
									showCancel
									confirmBtnBsStyle="success"
									cancelBtnBsStyle="danger"
									onConfirm={() => 
										this.deleteTopic()
									}
									onCancel={() =>
										this.setState({
											alert_confirm: false,
										})
									}
								>
									You won't be able to revert this!
								</SweetAlert>
							) : null}

                <Modal
                    isOpen={this.state.modelOpen}
                    toggle={() => this.setState({ modelOpen: false })}
                    centered={true}
                    backdrop="static"
                >
                    <AddTopic
                        isEditing={this.state.isEditing}
                        subexpertise={this.state.subExpertise}
                        expertiseOptions={this.state.expertiseOptions}
                        toggle={() => this.toggleModal({})}
                        reload={() => this.changePage(0)}
                    />
                </Modal>
            </React.Fragment>
        )
    }
}
export default SubExpertises;